import React from "react";
import { FaCaretDown, FaCog, FaSearch, FaUserPlus } from "react-icons/fa";
import { Link } from "react-router-dom";
import {
  setIsAdd,
  setIsConfirm,
  setMessage,
  setStartIndex,
} from "../../../../store/StoreAction";
import { StoreContext } from "../../../../store/StoreContext";
import useFetchDataLoadMore from "../../../custom-hooks/useFetchDataLoadMore";
import useLoadAll from "../../../custom-hooks/useLoadAll";
import Footer from "../../../footer/Footer";
import Header from "../../../header/Header";
import Navigation from "../../../navigation/Navigation";
import LoadMore from "../../../widget/LoadMore";
import ModalError from "../../../widget/ModalError";
import ModalSuccess from "../../../widget/ModalSuccess";
import ModalYesNo from "../../../widget/ModalYesNo";
import NoData from "../../../widget/NoData";
import Spinner from "../../../widget/Spinner";
import MembersSearch from "../../members/MembersSearch";
import ModalAddUser from "../user-role/ModalAddUser";

const SettingsRole = (props) => {
  const { store, dispatch } = React.useContext(StoreContext);
  const [toggle, setToggle] = React.useState(false);
  const search = React.useRef(null);
  const { result } = useLoadAll("/admin/role/read-role-all.php");
  const { loading, handleLoad, totalResult, handleSearch, handleChange } =
    useFetchDataLoadMore(
      "/admin/users/read-users.php",
      "/admin/users/read-users-all.php",
      25,
      null,
      "/admin/users/read-users-search.php"
    );
  const [itemEdit, setItemEdit] = React.useState(false);
  let count = 0;

  const handleAdd = () => {
    dispatch(setIsAdd(true));
  };

  const handleSuspend = (e, item) => {
    e.preventDefault();
    setItemEdit(item.users_aid);
    dispatch(setIsConfirm(true));
    dispatch(setStartIndex(0));
    dispatch(setMessage("Are you sure to suspend?"));
  };

  const handleEdit = (e, item) => {
    e.preventDefault();
    dispatch(setIsAdd(true));
    dispatch(setStartIndex(0));
    setItemEdit(item);
  };

  return (
    <>
      {store.isAdd && (
        <ModalAddUser result={result} edit={{ itemEdit, setItemEdit }} />
      )}
      {store.success && <ModalSuccess props={props} />}
      {store.error && <ModalError />}
      {store.isConfirm && (
        <ModalYesNo
          edit={{ itemEdit, setItemEdit }}
          url="/admin/users/archive-users.php"
        />
      )}
      <Header tog={{ toggle, setToggle }} />
      <Navigation tog={toggle} menu="settings" />
      <div className="main-content">
        <div className="container-fluid">
          <div className="title">
            <div className="row">
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                <span className="tab-title">USER ROLE</span>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6  col-xs-6">
                <button
                  className="btn right"
                  id="create-new"
                  onClick={handleAdd}
                >
                  <span>
                    <FaUserPlus />
                  </span>
                  <span>Create</span>
                </button>
              </div>
            </div>
          </div>

          <hr />

          <div className="member content-block clearfix mb--20">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12">
                <div className="content-box bg-highlight bg-lightcolor mb--20">
                  <div className="search-bar t-center mb--20">
                    <MembersSearch
                      handleSearch={handleSearch}
                      handleChange={handleChange}
                      store={store}
                      search={search}
                      loading={loading}
                    />
                  </div>
                  <div className="list mb--40">
                    <table id="" className="" cellSpacing="0" width="100%">
                      <thead className="title-box-light">
                        <tr>
                          <th className="">#</th>
                          <th className="">Name</th>
                          <th className="">Role</th>
                          <th className="desktop-view">Email</th>
                          <th className="t-right">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {store.resultSet.length > 0 ? (
                          store.resultSet.map((item, key) => {
                            count += 1;
                            return (
                              <tr key={key}>
                                <td className="">{count}</td>
                                <td className="">
                                  {item.users_fname + " " + item.users_lname}
                                </td>
                                <td className="">{item.role_name}</td>
                                <td className="desktop-view">
                                  {item.users_email}
                                </td>
                                <td className="t-right">
                                  <div className="dropdown">
                                    <span>
                                      <FaCog />
                                      <FaCaretDown />
                                    </span>
                                    <div className="dropdown-content">
                                      <p>
                                        <Link
                                          to="/settings"
                                          onClick={(e) => handleEdit(e, item)}
                                        >
                                          Edit info
                                        </Link>
                                      </p>
                                      <p>
                                        <Link
                                          to="/settings"
                                          onClick={(e) =>
                                            handleSuspend(e, item)
                                          }
                                        >
                                          Suspend
                                        </Link>
                                      </p>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan="7" style={{ height: "100px" }}>
                              {loading && <Spinner />}
                              <NoData />
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  {!store.isSearch && (
                    <LoadMore
                      handleLoad={handleLoad}
                      loading={loading}
                      // result={result}
                      store={store}
                      totalResult={totalResult}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default SettingsRole;
